"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnowAlgae = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var SnowAlgae = (function (_super) {
    __extends(SnowAlgae, _super);
    function SnowAlgae() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SNOW_ALGAE,
            cost: 12,
            tags: [Tags_1.Tags.PLANT],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oceans(2); }),
            metadata: {
                cardNumber: '211',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.plants(1).heat(1);
                    });
                }),
                description: 'Requires 2 oceans. Increase your Plant production and your heat production 1 step each.',
            },
        }) || this;
    }
    SnowAlgae.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.addProduction(Resources_1.Resources.HEAT, 1);
        return undefined;
    };
    return SnowAlgae;
}(Card_1.Card));
exports.SnowAlgae = SnowAlgae;
//# sourceMappingURL=SnowAlgae.js.map